<template>
  <div>
    <div class="map-container">
      <div class="map-interactive">
        <svg class="map-svg" id="odb-map" width="100%" height="100vh"></svg>
      </div>

      <div class="map-info">
        <div class="country-filter-box-top">
          <div class="filter-container">

            <div class="item-filter"><img @click="loadInitial"  alt="labels.title" class="logo logo-filter" :src="logoUrl" /></div>
            
            <div class="item-country-field item-filter">
              <select @change="selectCountry($event)">
                <option :key="code" :selected="country.code === activeCountry.code ? 'selected' : ''"  v-for="(country, code) in countriesList" :value="country.code">{{ country.name }}</option>
              </select>
            </div>
            
            <div class="item-filter">
              <ul class="languages">
                <li :key="code" @click="selectLanguage(language.code)" :class="language.code === selectedLang ? 'selected' : ''"  v-for="(language, code) in labels.languages" :data-lang="language.code">{{ language.name }}</li>
              </ul>
            </div>
  
          </div>
        </div>
  
        <div class="intro-container default-info item-info">
          <div class="info">
            <div class="default-header">
              <img class="logo" :src="logoUrl" />
              <h1 class="app-title title" v-html="labels.title"></h1>
            </div>
            <div class="app-excerpt">
              <p v-html="labels.description"></p>
              <p v-html="labels.description_2"></p>
              <p v-html="labels.description_3"></p>
              <p v-html="labels.description_4"></p>

              <div class="default-footer">
                  <a class="app-read-icon" href="/briberydivision"><img :alt="labels.title" :src="handUrl" /></a>
                  <a class="app-read-more" href="/briberydivision">{{ labels.read_more }}</a>
              </div>
              
            </div>
          </div>

        </div>

        <div class="country-data-box">
          <div v-if="activeCountry!=null" class="country-header">
            <h2>{{ activeCountry.name }}</h2>
          </div>
          <div v-if="activeCountry!=null" class="country-profile">

            <div class="country-tabs">
              <h3 @click="switchProfile('country-projects', 'cp-tab')" class="cp-tab articles-tab"  v-if="activeCountry.projects">{{ labels.projects }}</h3><h3 @click="switchProfile('country-articles', 'ca-tab')" class="ca-tab"  v-if="activeCountry.articles">{{ labels.articles }}</h3>
            </div>

            <div class="country-tabs-container">
            <div class="country-card" id="country-articles">

                <div class="item-info item-article" :key="index" v-for="(article, index) in activeCountry.articles">
                  <div class="project-data article-data">
                      <a class="article-logo" target="_blank" :href="article.url">
                        <img :alt="article.title" :src="article.logo" />
                      </a>
                    <h4><a class="article-title" target="_blank" :href="article.url">{{ article.title }}</a></h4>
                  </div>
                </div>
  
              </div>

            <div class="country-card" id="country-projects">

              <div @mouseover="activeProject(activeCountry.code, index)" :key="index" class="item-info item-project" v-for="(project, index) in activeCountry.projects">
                  <div class="project-data">
                    <h4>{{ project.name }}</h4>
                    <p>{{ project.description }}</p>
                    <div class="project-fields">
                      <span class="amount">{{ labels.amount }}: ${{ project.project_amount }}</span>

                      <span class="transactions"> {{ labels.transactions }} ({{ project.project_transaction_year }}): {{ project.number_transactions }}</span>
                    </div>
                    <p class="location"><font-awesome-icon :icon="icons.location" /> {{ project.project_location }}</p>
                  </div>
                  <div class="project-index">
                    <span v-html="(index+1)"></span>
                  </div>
                </div>

            </div>
            </div>

          </div>
        </div>
        
      </div>
      
      <div @click="loadInitial" class="icon-back">
        <span>
          <font-awesome-icon :icon="icons.back" /> {{ labels.back }}
        </span>
      </div>

    </div>
    <div class="map-footer">
      <embed-footer v-if="footerApp" :url-app="urlApp" :title-app="labels.project_title" :lead-app="labels.lead" :social-title="labels.social_title"></embed-footer>
    </div>
  </div>
</template>

<style lang="scss">
  @import "./assets/odb_map_styles.scss";
</style>

<script>

  import * as d3 from 'd3'
  import * as topojson from 'topojson'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
  import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons/faHandHoldingUsd'
  import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign'
  import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons/faGlobeAmericas'


  import EmbedFooter from './components/EmbedFooter'

  export default {
    name: 'App',
    components: {
      EmbedFooter,
      FontAwesomeIcon,
    },
    props: {
      languageApp: {
        type: String,
        default: 'en'
      },
      urlApp: null,
    },
    data () {
      return {
        footerApp: false,
        width: 0,
        height: 0,
        locations: [],
        svg: null,
        markerGroup: null,
        projection: null,
        initialScale: 500,
        initialCenter: [69, 4],
        zoomOut: 650,
        zoomScale: 1000,
        currentRotate: [],
        currentScale: null,
        path: null,
        center: null,
        countriesList: {},
        logoUrl: null,
        handUrl: null,
        dataMap: null,
        dataLand: null,
        wSpacing: 0.7,
        hSpacing: 0.45,
        activeCountry: {
          "code": "all"
        },
        dataInteractive: {
          "en": {},
          "es": {}
        },
        labels: null,
        selectedLang: this.languageApp,
        icons: {
          "amount": faDollarSign,
          "location": faMapMarkerAlt,
          "transactions": faHandHoldingUsd,
          "back": faGlobeAmericas
        },
      }
    },
    beforeMount() {
      this.dataMap = require('./data/world-map-topojson.json');
      this.logoUrl = require('./assets/logo_bribery_division.png');
      this.handUrl = require('./assets/hand.png');
      this.dataInteractive.en = require("./data/labels.json");
      this.dataInteractive.es = require("./data/labels_es.json");      
      this.currentRotate = this.initialCenter;
      this.currentScale = this.initialScale;
      this.labels = this.dataInteractive[this.selectedLang]
      this.countriesList = this.labels.countries
    },
    mounted() {
      this.width = this.calcWidth('#odb-map');
      this.height = this.calcHeight();
      this.wSpacing = (this.width < 770 ? 0.5 : this.wSpacing);
      this.hSpacing = (this.width < 770 ? 0.5 : this.hSpacing);
      this.initialScale = (this.width < 770 ? 300 : this.initialScale);
      this.center = [this.width*this.wSpacing, this.height*this.hSpacing];
      this.svg = d3.select('svg#odb-map').attr('width', this.width);
      this.markerGroup = this.svg.append('g');
      this.dataMap = topojson.feature(this.dataMap, this.dataMap.objects.countries);

      this.loadInitial();
      this.load_country_map();
      this.renderGraticule();
      this.renderGlobe();
      
    },
    methods: {
      loadInitial() {

        var $this = this;
        var countryPath = d3.selectAll("path.active");

        $this.svg.selectAll('circle.country_project')
        .remove();
        $this.svg.selectAll('text.project-label')
        .remove();
        $this.svg.selectAll('path.departments')
        .remove();

        $this.projection = d3.geoOrthographic()
        .scale($this.initialScale)
        .translate($this.center)
        .clipAngle(90)
        .precision(10)
        .rotate($this.initialCenter);
        
        $this.path = d3.geoPath().projection($this.projection);
        
        this.animateMap(countryPath, $this.initialScale, this.initialCenter, 1000, 0);

        countryPath.classed("selected", false);


        d3.select(".country-data-box")
        .transition()
        .delay(400)
        .style("left", "-600px");

        d3.select(".country-data-box")
        .transition()
        .delay(900)
        .style("display", "none");

        d3.select(".default-info")
        .transition()
        .delay(750)
        .style("display", "block");

        d3.select(".default-info")
        .transition()
        .delay(1000)
        .style("left", "0");

        d3.select(".icon-back")
        .transition()
        .delay(750)
        .style("bottom", "-300px");

        setTimeout(() => $this.activeCountry = $this.labels.countries['all'], 1000);


      },
      load_country_map() {
        const $this = this;
        const countries = this.dataInteractive.en.countries;
        Object.keys(countries).forEach(function(code) {
          if(!$this.dataInteractive.en.countries[code].file)
            return false;

          var features = require("./data/"+code+"_map.json");
          $this.dataInteractive.en.countries[code].map = features;
          $this.dataInteractive.es.countries[code].map = features;
        });
      },
      calcHeight() {
        return (document.querySelector(".odb-map-wrapper").offsetHeight);
      },
      calcWidth(map) {
        var mapContainer = d3.select(map).node();
        return mapContainer.getBoundingClientRect().width;
      }, 
      renderGlobe() {

        var $this = this;
        $this.renderCountryMap($this.dataMap.features, "country")
        $this.renderLabels();
        
      },
      renderLabels() {
        var $this = this;

        var labelsBg = $this.svg.append("g").attr("class", "country-labels-group");

        labelsBg.selectAll(".country-bg")
          .data($this.dataMap.features)
          .enter()
          .filter(function(d) { 
            if($this.countriesList[d.id])
              return d
            return false;
          })
          .append("text")
          .attr("class", "country-bg label-path")
          .attr("x", function(d) {
            return $this.path.centroid(d)[0] - 35;
          })
          .attr("y", function(d) {
            return $this.path.centroid(d)[1] - 10;
          })
          .text(function(d) {
            return $this.countriesList[d.id].name
          });

        labelsBg.selectAll(".country-label")
          .data($this.dataMap.features)
          .enter()
          .filter(function(d) { 
            if($this.countriesList[d.id])
              return d
            return false;
          })
          .append("text")
          .attr("class", "country-label label-path")
          .attr("x", function(d) {
            return $this.path.centroid(d)[0] - 35;
          })
          .attr("y", function(d) {
            return $this.path.centroid(d)[1] - 10;
          })
          .text(function(d) {
            return $this.countriesList[d.id].name
          });
      },
      renderGraticule() {
        const graticule = d3.geoGraticule()
          .step([10, 10]);

        this.svg.append("defs").append("path")
        .datum({type: "Sphere"})
        .attr("id", "sphere")
        .attr("d", this.path);

        this.svg.append("use")
        .attr("class", "stroke")
        .attr("xlink:href", "#sphere");

        this.svg.append("path")
        .datum(graticule)
        .attr("class", "graticule")
        .attr("d", this.path);

        // this.svg.insert("path", ".graticule")
        // .datum(this.dataLand)
        // .attr("class", "land")
        // .attr("d", this.path);

      },
      renderProjects(country_id) {

        var $this = this;

        if(!this.labels.countries[country_id].projects)
          return false

        var projectLocations = this.labels.countries[country_id].projects

        const markers = $this.markerGroup.selectAll('circle.country_project')
        .data(projectLocations);

        markers
        .enter()
        .append('circle')
        .merge(markers)
        .attr("id", function(d, index){
          return country_id+"-"+index;
        })
        .attr("class", "country_project")
        .attr('cx', d => $this.projection([d.longitude, d.latitude])[0])
        .attr('cy', d => $this.projection([d.longitude, d.latitude])[1])
        .transition()
        .attr('r', 10);

        $this.markerGroup.selectAll(".project-label")
        .data(projectLocations)
        .enter()
        .append("text")
        .attr("class", "project-label")
        .transition()
        .attr('x', d => ($this.projection([d.longitude, d.latitude])[0] - 4))
        .attr('y', d => ($this.projection([d.longitude, d.latitude])[1] + 5))
        .text(function(d, index) {
          return (index + 1)
        });

        $this.markerGroup.each(function () {
          this.parentNode.appendChild(this);
        });

      },
      selectLanguage(language) {
        this.selectedLang = language;
        this.labels = this.dataInteractive[this.selectedLang]
        this.countriesList = this.labels.countries
        this.activeCountry = this.labels.countries[this.activeCountry.code]
      },
      selectCountry(country) {
        var country_id = country.target.value;
        this.countryTransition(country_id);
      },
      countryTransition(country_id) {
        var countryPath = d3.select("#"+country_id)
        this.zoomScale = this.calculateScale(countryPath);
        var rotate = ((countryPath.attr("centroid")).split(",")).map(function(v){
          return v * -1;
        });

        this.svg.selectAll('circle.country_project')
        .remove();

        this.svg.selectAll('text.project-label')
        .remove();

        this.svg.selectAll('path.departments')
        .remove();

        setTimeout(() => this.activeCountry = this.labels.countries[country_id], 1000);

        setTimeout(() => this.renderProjects(country_id), 900);

        this.showData(country_id);
        this.loadCountryMap(country_id)
        this.animateMap(countryPath, this.zoomScale, rotate, 1000, 0);
      },
      switchProfile(tab, elm) {
        
        var cards = d3.selectAll(".country-card");
        var active = d3.select("#"+tab);
        var tabs = d3.selectAll(".country-tabs h3");
        var selectedTab = d3.select("."+elm);

        cards
        .transition()
        .delay(200)
        .style("left", "-600px");

        cards
        .transition()
        .delay(600)
        .style("display", "none");

        active
        .transition()
        .delay(600)
        .style("display", "block");

        active
        .transition()
        .delay(600)
        .style("left", "0px");

        tabs.classed("articles-tab", false)
        selectedTab.classed("articles-tab", true)

      },
      loadCountryMap(country_id) {
        var data = this.labels.countries[country_id];
        if(!data.map)
          return false

        var map = topojson.feature(data.map, data.map.objects.collection);
        
        this.renderCountryMap(map.features, "departments");
      },
      renderCountryMap (data, level) {

        var $this = this;
        
        $this.svg.selectAll("path."+level)
        .data(data)
        .enter().append("path")
        .attr("class", function(d) {
          if(d.id && $this.countriesList[d.id])
            return "active "+ level
          return level
        })
        .attr("d", $this.path)
        .attr("id", function(d) {
          if(d.id)
            return d.id
        })
        .attr("centroid", function(d) {
          if(d.id)
            return $this.projection.invert($this.path.centroid(d))
        })
        .attr("bounds", function(d) {
          if(d.id)
            return d3.geoBounds(d)
        })
        .on("click", function(d) {
          if(d.id && $this.countriesList[d.id]){
            $this.countryTransition(d.id)
          }
        });

      },
      animateMap (countryPath, scale, rotate, speed, delay) {
        var $this = this;
        var countries = $this.svg.selectAll("path");
        var labels = $this.svg.selectAll("text.label-path");

        $this.projection
        .scale(scale);
        
        countries
        .transition()
        .attrTween("d", function(d) {
          var r = d3.interpolate($this.currentRotate, rotate);
          var s = d3.interpolate($this.currentScale, scale);
          return function(t) {
            $this.projection
              .scale($this.currentScale > scale ? s(Math.pow(t,0.1)) : s(Math.pow(t,1)) )
              .rotate(r(Math.pow(t,0.1)))
            $this.path.projection($this.projection);
            $this.currentRotate = rotate;
            $this.currentScale = scale;
            return $this.path(d);
          }
        })
        .duration(speed);

        labels
        .transition()
        .delay(delay)
        .duration(speed)
        .attrTween("x", function(d) {
          return function() {
            return $this.path.centroid(d)[0] - 35;
          }
        })
        .attrTween("y", function(d) {
          return function() {
            return $this.path.centroid(d)[1] - 10;
          }
        });

        countries.classed("selected", false);
        countryPath.classed("selected", true);
      },
      calculateScale(countryPath) {
        var bounds = (countryPath.attr("bounds")).split(",");
        
        var distance = d3.geoDistance([bounds[0], bounds[1]], [bounds[2], bounds[3]]),
        scale = this.height / distance / Math.sqrt(2);
        return scale;
      },
      activeProject(code, index){
        var circles = this.svg.selectAll('circle.country_project');
        var project = d3.select("#"+code+"-"+index);

        circles.classed("active", false);
        project.classed("active", true);
      },
      showData(country_id) {
        //hide info
        var $this = this;
        var countryData = d3.select(".country-data-box");
        var defaultBox = d3.select(".default-info");
        var countryFilterDown = d3.select(".country-filter-box");
        var countryFilterTop = d3.select(".country-filter-box-top");
        var btnBack = d3.select(".icon-back");
        var defaultInfo = $this.labels.countries[country_id].default;

        if(defaultInfo != "projects") {
          $this.switchProfile('country-articles', 'ca-tab');
        } else {
          $this.switchProfile('country-projects', 'cp-tab');
        }

        defaultBox
        .transition()
        .delay(200)
        .style("left", "-600px");

        countryData
        .transition()
        .delay(100)
        .style("left", "-600px");

        countryData
        .transition()
        .delay(450)
        .style("display", "none");
        

        defaultBox
        .transition()
        .delay(900)
        .style("display", "none");

        countryData
        .transition()
        .delay(500)
        .style("display", "block");

        countryData
        .transition()
        .delay(850)
        .style("left", "0");

        btnBack
        .transition()
        .delay(850)
        .style("bottom", "68px");

        countryFilterDown
        .transition()
        .delay(200)
        .style("bottom", "-100px");

        countryFilterDown
        .transition()
        .delay(500)
        .style("display", "none");

        countryFilterTop
        .transition()
        .delay(900)
        .style("top", "0");

      }
    }
  };

</script>